const KEY = 'access-users-v1';
let audit; try{ audit = require('../bread/auditLogService'); }catch{ audit = null; }
let access; try{ access = require('./accessService'); }catch{ access = null; }

const seedUsers = [
  { id: 'usr-alice', displayName: 'Alice Johnson', email: 'alice@krotrust.org', status: 'active', roles: ['role-admin'], createdAt: '2024-12-01', lastLoginAt: '2025-09-15T10:00:00Z' },
  { id: 'usr-bob', displayName: 'Bob Martin', email: 'bob@krotrust.org', status: 'active', roles: ['role-manager'], createdAt: '2025-01-12', lastLoginAt: '2025-09-16T09:20:30Z' },
  { id: 'usr-carol', displayName: 'Carol Lee', email: 'carol@krotrust.org', status: 'suspended', roles: [], createdAt: '2025-02-05', lastLoginAt: null },
];

function load(){
  try{ const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) : seedUsers; }catch{ return seedUsers; }
}

let users = load();
const subs = new Set();

function save(){ try{ localStorage.setItem(KEY, JSON.stringify(users)); }catch{} }
function publish(){ save(); subs.forEach(cb=>{ try{ cb(users); }catch{} }); }

export function subscribe(cb){ subs.add(cb); cb(users); return ()=> subs.delete(cb); }
export function list(){ return users.slice(); }
export function findById(id){ return users.find(u=> u.id === id) || null; }
export function findByEmail(email){ return users.find(u=> u.email.toLowerCase() === String(email||'').toLowerCase()) || null; }

function ensureUniqueEmail(email, ignoreId=null){
  const exists = users.some(u=> u.email.toLowerCase() === String(email||'').toLowerCase() && u.id !== ignoreId);
  if(exists) throw new Error('Email already exists');
}

function genId(){ return 'usr-' + Math.random().toString(36).slice(2,9); }

export function upsert(user){
  const payload = { ...user };
  if(!payload.email) throw new Error('Email is required');
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) throw new Error('Invalid email');
  const idx = payload.id ? users.findIndex(u=> u.id === payload.id) : -1;
  ensureUniqueEmail(payload.email, idx>=0 ? users[idx].id : null);
  const now = new Date().toISOString();
  if(idx>=0){
    const before = users[idx];
    users[idx] = { ...before, ...payload };
    publish();
    try{ audit && audit.add && audit.add({ user: 'system', action:'user.update', target: users[idx].id, status:'success', ip:'-' }); }catch{}
    return users[idx];
  } else {
    const created = { id: genId(), displayName: payload.displayName || payload.email.split('@')[0], email: payload.email, status: payload.status || 'active', roles: Array.isArray(payload.roles)? payload.roles : [], createdAt: now, lastLoginAt: null };
    users.unshift(created);
    publish();
    try{ audit && audit.add && audit.add({ user:'system', action:'user.create', target: created.id, status:'success', ip:'-' }); }catch{}
    return created;
  }
}

export function remove(id){ users = users.filter(u=> u.id !== id); publish(); try{ audit && audit.add && audit.add({ user:'system', action:'user.delete', target:id, status:'success', ip:'-' }); }catch{} }

export function setStatus(id, status){
  const u = users.find(u=> u.id === id); if(!u) return;
  u.status = status; publish();
  try{ audit && audit.add && audit.add({ user:'system', action: status==='active'?'user.enable':'user.disable', target:id, status:'success', ip:'-' }); }catch{}
}

export function assignRole(id, roleId){
  const u = users.find(u=> u.id === id); if(!u) return;
  const set = new Set(u.roles || []);
  // validate role exists
  try{
    const st = access && access.getState && access.getState();
    if(st && st.roles && !st.roles.some(r=> r.id === roleId)) throw new Error('Role not found');
  }catch{}
  set.add(roleId);
  u.roles = Array.from(set);
  publish();
  try{ audit && audit.add && audit.add({ user:'system', action:'user.assignRole', target:`${id}:${roleId}`, status:'success', ip:'-' }); }catch{}
}

export function revokeRole(id, roleId){
  const u = users.find(u=> u.id === id); if(!u) return;
  const set = new Set(u.roles || []);
  set.delete(roleId);
  u.roles = Array.from(set);
  publish();
  try{ audit && audit.add && audit.add({ user:'system', action:'user.revokeRole', target:`${id}:${roleId}`, status:'success', ip:'-' }); }catch{}
}

export function resetPassword(id){
  // placeholder: in real system, trigger email flow or IdP action
  try{ audit && audit.add && audit.add({ user:'system', action:'user.resetPassword', target:id, status:'success', ip:'-' }); }catch{}
  return true;
}

export function search({ q='', status='all', role='all' }={}){
  const query = q.trim().toLowerCase();
  return users.filter(u=>{
    if(status!=='all' && u.status !== status) return false;
    if(role!=='all' && !(u.roles||[]).includes(role)) return false;
    if(!query) return true;
    return [u.displayName, u.email, ...(u.roles||[])].some(v=> String(v||'').toLowerCase().includes(query));
  });
}

export function exportJSON(){ return users; }
export function importJSON(arr){ if(!Array.isArray(arr)) return; users = arr; publish(); }
